import { render, staticRenderFns } from "./CardFile.vue?vue&type=template&id=4c896776&scoped=true"
import script from "./CardFile.vue?vue&type=script&lang=js"
export * from "./CardFile.vue?vue&type=script&lang=js"
import style0 from "./CardFile.vue?vue&type=style&index=0&id=4c896776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c896776",
  null
  
)

export default component.exports